import { toast, throttle } from '@/utils';
import store from '@/store';

const routerFn = {
  // 登录超时 / 认证失败
  tokenTimeout: throttle(() => {
    toast.fail('登录状态失效，请重新登录');
    // 退出登录
    store.commit('home/logout');
  }, 1000),
  // 返回包含所有routeName(除login外)的数组
  getRouteNameList: (routes, data = []) => {
    routes.forEach(item => {
      const routeName = item.routeName;
      if (routeName !== 'login') {
        data.push(routeName);
        if (item.children) routerFn.getRouteNameList(item.children, data);
      }
    });
    return data;
  },
  // 通过path或routeName获取对应的路由信息
  getRoute: (routes, data, key = 'path') => {
    let routeData = null;
    for (let i in routes) {
      if (routes[i][key] === data) {
        routeData = routes[i];
      } else if (routes[i].children) {
        routeData = routerFn.getRoute(routes[i].children, data, key);
      }
      if (routeData) return routeData;
    }
  },
  // 根据父级routeName递归返回当前父级的第一个子级路由当做定向路由
  recursionRoute: (navList, parentRouteName) => {
    for (let i in navList) {
      if (navList[i].routeName === parentRouteName) {
        for (let j in navList[i].children) {
          if (navList[i].children[j].hidden === false) {
            return navList[i].children[j].routeName;
          }
        }
      } else if (navList[i].children && navList[i].children.length > 0) {
        let returnRouteName = routerFn.recursionRoute(navList[i].children, parentRouteName);
        if (returnRouteName) return returnRouteName;
      }
    }
  },
  // redirect路由重定向父级routeName定向子级路由(配合recursionRoute使用)
  redirectRoute: parentRouteName => {
    const navList = store.state.home.navList || [];
    if (navList.length > 0) {
      // home路由
      if (parentRouteName === 'home') {
        return { name: navList[0].routeName };
      } else {
        // 其他路由
        let returnRouteName = routerFn.recursionRoute(navList, parentRouteName);
        return { name: returnRouteName };
      }
    } else {
      return { name: '' };
    }
  }
}

export default routerFn;